import { IService } from './IService';
import { AngularFireDatabase } from '@angular/fire/database';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppSettings } from './app-settings';
import { LoadingService } from './loading-service';

@Injectable({ providedIn: 'root' })
export class ListViewSwipeToDismissService implements IService {

  constructor(public af: AngularFireDatabase, private loadingService: LoadingService) { }

  getId = (): string => 'swipeToDismiss';

  getTitle = (): string => 'Swipe to dismiss';

  getAllThemes = (): Array<any> => {
    return [
      { 'url': 'swipe-to-dismiss/0', 'title': 'Medium item', 'theme': 'layout1' },
      { 'url': 'swipe-to-dismiss/1', 'title': 'Medium item with location', 'theme': 'layout2' },
      { 'url': 'swipe-to-dismiss/2', 'title': 'Full with image + left swipe', 'theme': 'layout3' }
    ];
  }

  getDataForTheme = (menuItem: any): Array<any> => {
    return this[
      'getDataFor' +
      menuItem.theme.charAt(0).toUpperCase() +
      menuItem.theme.slice(1)
    ]();
  }

  //* Data Set for page 1
  getDataForLayout1 = (): any => {
    return {
      'headerTitle': 'Medium item',
      'listHeaderTitle': 'Upcoming',
      'listTitle': 'News Products',
      "title": "Rear Brake Rotors Kit + Ceramic Pads",
      "description": "Order",
      "data": "16 Jan 2020",
      "time": "08:00 am",
      "image": "assets/imgs/avatar/3.jpg",
      'items': [
        {
          'id': 1,
          "title": "Full Kit Cross-Drilled Slotted Brake",
          "description": "Cars",
          "image": "assets/imgs/avatar/1.jpg",
          "details": "$200",
          'buy': "buy now",
          'iconDelate': 'trash',
          'iconCalendar': 'calendar'
        },
        {
          'id': 2,
          "title": "Power Stop K5828 Front & Rear Brake",
          "description": "Cars",
          "image": "assets/imgs/avatar/2.jpg",
          "details": "$200",
          'buy': "buy now",
          'iconDelate': 'trash',
          'iconCalendar': 'calendar'
        },
        {
          'id': 3,
          "title": "Rear Brake Rotors Kit + Ceramic Pads",
          "description": "Cars",
          "image": "assets/imgs/avatar/7.jpg",
          "details": "$200",
          'buy': "buy now",
          'iconDelate': 'trash',
          'iconCalendar': 'calendar'
        },
        {
          'id': 4,
          "title": "Rear Brake Rotors Kit + Ceramic Pads",
          "description": "Cars",
          "image": "assets/imgs/avatar/4.jpg",
          "details": "$200",
          'buy': "buy now",
          'iconDelate': 'trash',
          'iconCalendar': 'calendar'
        },
        {
          'id': 5,
          "title": "Rear Brake Rotors Kit + Ceramic Pads",
          "description": "Cars",
          "image": "assets/imgs/avatar/6.jpg",
          "details": "$200",
          'buy': "buy now",
          'iconDelate': 'trash',
          'iconCalendar': 'calendar'
        },
        {
          'id': 6,
          "title": "Rear Brake Rotors Kit + Ceramic Pads",
          "description": "Cars",
          "image": "assets/imgs/avatar/7.jpg",
          "details": "$200",
          'buy': "buy now",
          'iconDelate': 'trash',
          'iconCalendar': 'calendar'
        },
        {
          'id': 7,
          "title": "Rear Brake Rotors Kit + Ceramic Pads",
          "description": "Cars",
          "image": "assets/imgs/avatar/8.jpg",
          "details": "$200",
          'buy': "buy now",
          'iconDelate': 'trash',
          'iconCalendar': 'calendar'
        }
      ]
    };
  }


  //* Data Set for page 2
  getDataForLayout2 = (): any => {
    return {
      'headerTitle': 'Medium item with location',
      'items': [
        {
          'id': 1,
          "title": "Power Stop K5828 Front & Rear Brake",
          "description": "New car shop",
          "image": "assets/imgs/avatar/8.jpg",
          "details": "Main Street 32, NYC",
          "icon": "location",
          'iconDelate': 'trash',
          'iconUndo': 'arrow-undo'
        },
        {
          'id': 2,
          "title": "Full Kit Cross-Drilled Slotted Brake",
          "description": "New car shop",
          "image": "assets/imgs/avatar/7.jpg",
          "details": "Main Street 32, NYC",
          "icon": "location",
          'iconDelate': 'trash',
          'iconUndo': 'arrow-undo'
        },
        {
          'id': 3,
          "title": "Rear Brake Rotors Kit + Ceramic Pads",
          "description": "New car shop",
          "image": "assets/imgs/avatar/6.jpg",
          "details": "Main Street 32, NYC",
          "icon": "location",
          'iconDelate': 'trash',
          'iconUndo': 'arrow-undo'
        },
        {
          'id': 4,
          "title": "Power Stop K6268-36 Z36 Truck",
          "description": "New car shop",
          "image": "assets/imgs/avatar/5.jpg",
          "details": "Main Street 32, NYC",
          "icon": "location",
          'iconDelate': 'trash',
          'iconUndo': 'arrow-undo'
        },
        {
          'id': 5,
          "title": "Power Stop K5828 Front & Rear Brake",
          "description": "New car shop",
          "image": "assets/imgs/avatar/4.jpg",
          "details": "Main Street 32, NYC",
          "icon": "location",
          'iconDelate': 'trash',
          'iconUndo': 'arrow-undo'
        },
        {
          'id': 6,
          "title": "Power Stop K6268-36 Z36 Truck",
          "description": "New car shop",
          "image": "assets/imgs/avatar/3.jpg",
          "details": "Main Street 32, NYC",
          "icon": "location",
          'iconDelate': 'trash',
          'iconUndo': 'arrow-undo'
        },
        {
          'id': 7,
          "title": "Rear Brake Rotors Kit + Ceramic Pads",
          "description": "New car shop",
          "image": "assets/imgs/avatar/2.jpg",
          "details": "Main Street 32, NYC",
          "icon": "location",
          'iconDelate': 'trash',
          'iconUndo': 'arrow-undo'
        },
        {
          'id': 8,
          "title": "Power Stop K6268-36 Z36 Truck",
          "description": "New car shop",
          "image": "assets/imgs/avatar/1.jpg",
          "details": "Main Street 32, NYC",
          "icon": "location",
          'iconDelate': 'trash',
          'iconUndo': 'arrow-undo'
        }
      ]
    };
  }

  //* Data Set for page 3
  getDataForLayout3 = (): any => {
    return {
      'headerTitle': 'Full with image + left swipe',
      'items': [
        {
          'id': 1,
          'title': 'Mercedes-Benz GT',
          'description': ' Sport Cars',
          'image': 'assets/imgs/background/5.jpg',
          'iconDelate': 'trash',
          'iconCalendar': 'calendar'
        },
        {
          'id': 2,
          'title': 'Jaguar F-Type',
          'description': 'Sport Cars',
          'image': 'assets/imgs/background/6.jpg',
          'iconDelate': 'trash',
          'iconCalendar': 'calendar'
        },
        {
          'id': 3,
          'title': 'BMW 8-Series',
          'description': 'Sport Cars',
          'image': 'assets/imgs/background/7.jpg',
          'iconDelate': 'trash',
          'iconCalendar': 'calendar'
        },
        {
          'id': 4,
          'title': 'BMW Z4',
          'description': 'Sport Cars',
          'image': 'assets/imgs/background/1.jpg',
          'iconDelate': 'trash',
          'iconCalendar': 'calendar'
        },
        {
          'id': 5,
          'title': 'Porsche Boxster',
          'description': 'Sport Cars',
          'image': 'assets/imgs/background/2.jpg',
          'iconDelate': 'trash',
          'iconCalendar': 'calendar'
        }
      ]
    };
  }

  load(item: any): Observable<any> {
    const that = this;
    that.loadingService.show();
    if (AppSettings.IS_FIREBASE_ENABLED) {
      return new Observable(observer => {
        this.af
          .object('listView/swipeToDismiss/' + item.theme)
          .valueChanges()
          .subscribe(snapshot => {
            that.loadingService.hide();
            observer.next(snapshot);
            observer.complete();
          }, err => {
            that.loadingService.hide();
            observer.error([]);
            observer.complete();
          });
      });
    } else {
      return new Observable(observer => {
        that.loadingService.hide();
        observer.next(this.getDataForTheme(item));
        observer.complete();
      });
    }
  }
}
